import { render } from "./SnoozeWrapper.vue?vue&type=template&id=78ef15d8&scoped=true&ts=true"
import script from "./SnoozeWrapper.vue?vue&type=script&lang=ts"
export * from "./SnoozeWrapper.vue?vue&type=script&lang=ts"

import "./SnoozeWrapper.vue?vue&type=style&index=0&id=78ef15d8&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78ef15d8"]])

export default __exports__